import React, { Component } from "react";

import TableHeader from "./TableHeader";
import TableBody from "./TableBody";
import TableFooter from "./TableFooter";

import lbl from "../../data/Labels.json";

import _ from "lodash";
import DataResponse from "./DataResponse";

class Table extends Component {
  state = {
    sortColumn: { path: "id", order: "asc" },
    query: "",
    data: [],
    error: [],
    summary: [],
  };

  componentDidMount = () => {
    const { data } = this.props;

    this.setState({ data: data?.data || data, summary: data?.summary });
  };

  static getDerivedStateFromProps(nextProps) {
    return {
      query: nextProps.query,
      data: nextProps?.data?.data || nextProps?.data,
      summary: nextProps?.data?.summary,
      error: nextProps?.data?.data,
    };
  }

  handleFilter = (arr, searchKey) => {
    return arr.filter((obj) =>
      Object.keys(obj).some((key) => {
        return obj[key] && obj[key].toString().includes(searchKey);
      })
    );
  };

  handleSort = (col) => {
    this.setState({ sortColumn: col });
  };

  getUpdateData = () => {
    const { data, query, sortColumn, error } = this.state;

    let newData = data;

    if (query) {
      newData = this.handleFilter(data, query);
    }

    let sorted = _.orderBy(newData, [sortColumn.path], [sortColumn.order]);

    return { data: sorted, error };
  };

  render() {
    const { summary, sortColumn } = this.state;
    const { columns, editMode, total, colWidths } = this.props;
    const { data, error } = this.getUpdateData();

    if (error?.error) {
      return <DataResponse error={error} />;
    }

    return (
      <table>
        {Array.isArray(colWidths) && colWidths.length > 0 ? (
          <colgroup>
            {colWidths.map((width, index) => (
              <col key={index} style={{ width }} />
            ))}
          </colgroup>
        ) : null}
        <TableHeader
          columns={columns}
          handleSort={this.handleSort}
          sortColumn={sortColumn}
        />
        <TableBody
          data={data?.data || data}
          editMode={editMode}
          columns={columns}
        />
        <TableFooter columns={columns} summary={summary} total={total} />
      </table>
    );
  }
}

export default Table;
